
<div v-if="msg" class="ui negative message appMessage hidden">
  <i v-if="closable" @click="hide" class="close icon"></i>
  <span>{{ msg }}</span>
</div>
